import { css } from '@emotion/react';

export const globalStyles = css`
  #root {
    height: 100%;
  }
`;
